/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="111.96"
        height="65.05"
        viewBox="0 0 111.96 65.05"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M102.94 54.66a1.25 1.25 0 0 1-1.25-1.25V5.21a2.83 2.83 0 0 0-2.94-2.71H13a2.83 2.83 0 0 0-2.94 2.71v48.2a1.25 1.25 0 0 1-2.5 0V5.21A5.33 5.33 0 0 1 13 0h85.74a5.33 5.33 0 0 1 5.44 5.21v48.2a1.25 1.25 0 0 1-1.25 1.25"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M9.32 63.03h93.38a6 6 0 0 0 4.56-1.58c1.89-1.82 2.44-4.75 2.6-6.27-10.52 0-97.27-.11-107.79-.12.25 2.35 1.47 8 7.25 8Zm93.7 2H9.31C2 65.03 0 57.9 0 54.11c0-1 .93-1 1.61-1h1.75l59.77.05 43.83.06c5 0 5 0 5 1 0 .23 0 5.59-3.27 8.71a7.8 7.8 0 0 1-5.63 2.15Z"
          className="icon-fill icon-base"/><path
          fill="#fff"
          d="M16.39 53.36h79.14v-45H16.39ZM96 54.86H15.92a1 1 0 0 1-1-1V7.94a1 1 0 0 1 1-1H96a1 1 0 0 1 1 1v45.88a1 1 0 0 1-1 1Z"
          className="icon-fill icon-base"/><path
          fill="#ffb81c"
          d="m46.64 19.21 26.27 4.25-13.35 19.17-12.92-23.42z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="m80.57 39.2-3.95 5.53-14.43-10.31 3.96-5.53L80.57 39.2z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ComputerScreenWithMouseArrowIcon';

export default Icon;
